// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data_table_header{border-bottom:1px solid #222!important;text-align:left;background:#444;color:#fff!important;padding:0 5px;height:48px}", ""]);
// Exports
module.exports = exports;
